import { extractFeedData } from './feed/feed';
import { extractTripData } from './trip';
import { extractNextTripData } from './nextTrip';

export function convertDashboardData(response) {
  const feedData = extractFeedData(response);
  const tripData = extractTripData(
    response && response.kpis ? response.kpis : {}
  );
  const nextTripData = extractNextTripData(
    response && response.kpis ? response.kpis : {}
  );

  return {
    feedData,
    tripData,
    nextTripData
  };
}
